import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import {
  STYLES,
  SYMBOLS,
  TEST_IDS,
  WHITESPACE,
  emptyString,
  textStrings,
  DEFAULT_VALUE,
  PERCENTAGE_FORMAT_CONSTANTS,
  RATING_DEFAULT_VALUES,
  questionsAverageRatingCardConstants,
} from "../../../../constants";
import { QuestionsAverageRatingCard } from "../questionsAverageRatingCard/questionsAverageRatingCard";

const { SEE_AVERAGES, SINCE_LAST, DAYS, QUESTION_TEST_ID_PREFIX } =
  questionsAverageRatingCardConstants;

export const AverageRatingCard = ({
  title,
  isGroup,
  dayCounts,
  classNames = emptyString,
  bodyClassNames = emptyString,
  averageRating,
  previousAverageRating,
  averageRatingQuestionsData,
}) => {
  const [showQuestionsAverageRatingCard, setShowQuestionsAverageRatingCard] =
    useState(false);

  const handleViewAverages = () => {
    setShowQuestionsAverageRatingCard((prev) => !prev);
  };

  const calculatePercentageChange = (oldValue, newValue) => {
    if (oldValue === DEFAULT_VALUE && newValue === DEFAULT_VALUE) {
      return `${RATING_DEFAULT_VALUES.ZERO_CHANGE}${SYMBOLS.PERCENTAGE}${WHITESPACE.SPACE}`;
    }
    if (oldValue === DEFAULT_VALUE && newValue !== DEFAULT_VALUE) {
      return `${RATING_DEFAULT_VALUES.FULL_CHANGE}${SYMBOLS.PERCENTAGE}${WHITESPACE.SPACE}`;
    }

    const numerator = Math.abs(newValue - oldValue);
    let percentage = (numerator / oldValue) * PERCENTAGE_FORMAT_CONSTANTS.MULTIPLIER;
    percentage = Math.abs(
      parseFloat(isNaN(percentage) ? DEFAULT_VALUE : percentage)
    ).toFixed(PERCENTAGE_FORMAT_CONSTANTS.DECIMAL_PLACES);

    return `${percentage}${SYMBOLS.PERCENTAGE}${WHITESPACE.SPACE}`;
  };

  const getRatingChangeClassAndIcon = () => {
    if (previousAverageRating < averageRating) {
      return {
        className: STYLES.TEXT_SUCCESS,
        icon: (
          <FontAwesomeIcon icon={faChevronUp} className={STYLES.ICON_SPACING} />
        ),
      };
    } else if (previousAverageRating === averageRating) {
      return {
        className: STYLES.TEXT_SECONDARY,
        icon: null,
      };
    } else {
      return {
        className: STYLES.TEXT_DANGER,
        icon: (
          <FontAwesomeIcon icon={faChevronDown} className={STYLES.ICON_SPACING} />
        ),
      };
    }
  };

  const ratingChange = getRatingChangeClassAndIcon();

  return (
    <div className={`w-100 ${classNames}`}>
      <div
        className={`card shadow status-response-card w-100 ${classNames}`}
        data-testid={title}
      >
        <div className="card-body px-0 pb-0 mx-0">
          <h5 className="text-center responses-title">{title}</h5>
          <hr />
          <h1 className={`text-center responses pt-3 ${bodyClassNames}`}>
            {averageRating}
          </h1>
          <p className={`text-center responses ${bodyClassNames}`}>
            {averageRatingQuestionsData ? (
              <span className={ratingChange.className}>
                {ratingChange.icon}
                {calculatePercentageChange(
                  previousAverageRating,
                  averageRating
                )}
                {`${SINCE_LAST} ${dayCounts} ${DAYS}`}
              </span>
            ) : (
              textStrings.NO_DATA_TO_DISPLAY
            )}
          </p>
          <div className="text-center mt-3">
            <button
              data-testid={TEST_IDS.AVERAGE_RATING_TOGGLE}
              disabled={!averageRatingQuestionsData}
              className={`transaction-card-button ${
                showQuestionsAverageRatingCard ? STYLES.ACTIVE : emptyString
              }`}
              onClick={handleViewAverages}
            >
              {SEE_AVERAGES}
            </button>
          </div>
        </div>
      </div>
      {/* Conditionally render the averages card based on the state */}
      {showQuestionsAverageRatingCard && (
        <div
          className=" d-md-flex mb-3 justify-content-between mt-3"
          data-testid={`${QUESTION_TEST_ID_PREFIX}${title}`}
        >
          <QuestionsAverageRatingCard
            isGroup={isGroup}
            dayCounts={dayCounts}
            surveyQuestionsAverageDetails={averageRatingQuestionsData}
          />
        </div>
      )}
    </div>
  );
};
